import TeamCard from "./TeamCard";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import '../../../styles/Home/team.scss';




const Team = () => {
  return (
    <section id="team" className="team">
      <h1 className="team__heading">
        Our Team
      </h1>

      <div className="team__cards">
        <Carousel
          additionalTransfrom={0}
          arrows
          autoPlay
          autoPlaySpeed={3000}
          centerMode={false}
          className=""
          containerClass="container-with-dots"
          dotListClass=""
          draggable
          focusOnSelect={false}
          infinite
          itemClass=""
          keyBoardControl
          minimumTouchDrag={80}
          pauseOnHover
          renderArrowsWhenDisabled={false}
          renderButtonGroupOutside={false}
          renderDotsOutside={false}
          responsive={{
            desktop: {
              breakpoint: {
                max: 3000,
                min: 1360
              },
              items: 3,
              partialVisibilityGutter: 40
            },
            mobile: {
              breakpoint: {
                max: 750,
                min: 0
              },
              items: 1,
              partialVisibilityGutter: 30
            },
            tablet: {
              breakpoint: {
                max: 1360,
                min: 750
              },
              items: 2,
              partialVisibilityGutter: 30
            }
          }}
          rewind={false}
          rewindWithAnimation={false}
          rtl={false}
          shouldResetAutoplay
          showDots={false}
          sliderClass=""
          slidesToSlide={1}
          swipeable
        >

          <TeamCard
            pfp='/images/teammembers/abdulraheem.jpeg'
            name='Abdul Raheem'
            role='GDSC Lead'
            linkedin='https://www.linkedin.com/in/xfarooqi/'
            github={null}
            twitter={null}
          />

          <TeamCard
            pfp='/images/teammembers/ahmadghani.jpeg'
            name='Ahmad Ghani'
            role='Web Development Lead'
            linkedin='https://www.linkedin.com/in/ahmadghani'
            github='https://github.com/ahmad44452'
            twitter={null}
          />

          <TeamCard
            pfp='/images/teammembers/ahmadchaudhary.jpeg'
            name='Ahmad Chaudhary'
            role='Event Management Lead'
            linkedin='https://www.linkedin.com/in/muhammad-ahmad-662835153'
            github={null}
            twitter='https://twitter.com/M_Ahmad_9'
          />

          <TeamCard
            pfp='/images/teammembers/arslankhalid.jpeg'
            name='Arslan Khalid'
            role='Graphics Lead'
            linkedin='https://www.linkedin.com/in/arslan4real/'
            github={null}
            twitter='https://twitter.com/arslan4real_'
          />

          <TeamCard
            pfp='/images/teammembers/habeeburrehman.png'
            name='Habib ur Rehman'
            role='Public Relation Lead'
            linkedin='https://www.linkedin.com/in/hafiz-habib-ur-rehman-021637205'
            github={null}
            twitter='https://twitter.com/thehabiburrehma'
          />

          <TeamCard
            pfp='/images/teammembers/ibraarzahoor.jpeg'
            name='Ibrar Zahoor'
            role='Creative Lead'
            linkedin='https://www.linkedin.com/in/ibrar-zahoor-56916518a'
            github={null}
            twitter='https://twitter.com/zahoor_ibrar?t=3WAVqllXWcIvIYEnS2Jmog&s=09'
          />

          <TeamCard
            pfp='/images/teammembers/nabeelahmad.jpeg'
            name='Nabeel Ahmad'
            role='Competative Programming Lead'
            linkedin='https://www.linkedin.com/in/nabeelahmedjh/'
            github={null}
            twitter='https://twitter.com/nabeelahmedjh'
          />

          <TeamCard
            pfp='/images/teammembers/ehtasaam.jpeg'
            name='Eatsam Ul Haq'
            role='Technical Lead'
            linkedin='https://www.linkedin.com/in/eatsam-ul-haq-a40b431b5'
            github={null}
            twitter={null}
          />

          <TeamCard
            pfp='/images/teammembers/daniyalahmad.jpeg'
            name='Daniyal Ahmad'
            role='Technical Lead'
            linkedin='https://www.linkedin.com/in/wordpress-and-seoexpert/'
            github={null}
            twitter='https://twitter.com/DaniyalAhmadK11'
          />

          <TeamCard
            pfp='/images/teammembers/alisajjad.jpeg'
            name='Ali Sajjad'
            role='Game Dev Lead'
            linkedin='https://www.linkedin.com/in/ali-sajjad-4007511ba/'
            github={null}
            twitter='https://twitter.com/chali13490'
          />

        </Carousel>
      </div>
    </section>
  )
}

export default Team;